export default __webpack_public_path__ + "static/media/2.d1758078.png";